import React from 'react';

import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import Layout from "components/Layout";
import Landing from "components/Pages/Landing";
import Withdraw from "components/Pages/Withdraw/index";
import Home from "components/Pages/Home";

import {StakingContractProvider} from "context/StakingContract/index";

import './assets/styles/App.scss';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <StakingContractProvider>
            <Layout page={<Landing/>}/>
          </StakingContractProvider>
        </Route>
        <Route exact path="/withdraw">
          <StakingContractProvider>
            <Layout page={<Withdraw/>}/>
          </StakingContractProvider>
        </Route>
        {/* <Route exact path="/stake">
          <StakingContractProvider>
            <Layout page={<Home/>}/>
          </StakingContractProvider>
        </Route> */}
      </Switch>
    </Router>
  );
}

export default App;
